if (!customElements.get("tpt-viewed-product")) {
    customElements.define(
        "tpt-viewed-product",
        class TptViewedProduct extends HTMLElement {
            constructor() {
                super();
                this.viewedComponent = this;
                this.viewedWrapper = this.querySelector("[data-viewed-container]");
            }

            connectedCallback() {
                const handleIntersection = (entries, observer) => {
                    if (!entries[0].isIntersecting) return;
                    observer.unobserve(this);

                    const viewedArr = JSON.parse(sessionStorage.getItem("viewedProduct"));
                    var productContainer = "";

                    if (viewedArr) {
                        var viewedItem = "";

                        viewedArr.forEach((item) => {
                            const productUrl = window.Shopify.routes.root + "products/" + item.product_handle + "?section_id=tpt-viewed-product-item";

                            productContainer = `<div class="tpt-viewed_product-item" data-product-handle="${productUrl}">
									<div class="tpt-skeleton" style="padding-bottom: ${window.viewed_settings.product_ratio}"></div>
									<div class="tpt-skeleton" style="width: 80%; height: 30px; margin: 10px auto 2px;"></div>
									<div class="tpt-skeleton" style="width: 80%; max-width: 120px; height: 30px; margin: 10px auto 0;"></div>
								</div>`;

                            viewedItem = viewedItem + productContainer;
                        });

                        this.viewedWrapper.insertAdjacentHTML("beforeend", viewedItem);

                        setTimeout(() => {
                            const productView = this.viewedComponent.querySelectorAll("[data-product-handle]");

                            productView.forEach((product) => {
                                const productUrl = product.getAttribute("data-product-handle");

                                fetch(productUrl)
                                    .then((response) => response.text())
                                    .then((responseText) => {
                                        const responseHTML = new DOMParser().parseFromString(responseText, "text/html");
                                        const dataHtml = responseHTML.querySelector(".shopify-section").innerHTML;

                                        product.innerHTML = dataHtml;
                                    })
                                    .finally(() => {});
                            });
                        }, 500);
                    } else {
                        this.closest("section").style.display = "none";
                    }
                };

                new IntersectionObserver(handleIntersection.bind(this), { rootMargin: "0px 0px 0px 0px" }).observe(this);
            }
        },
    );
}
